// src/components/ProjectAnalysis.js
import React, { useState } from 'react';
import { TrendingUp, Search } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';

// Lista de tickers conocidos para demo
const KNOWN_TICKERS = ['BTC', 'ETH', 'BNB', 'SOL', 'DOT'];

const generateAnalysis = (ticker) => {
  // Convertir a mayúsculas para comparación
  const upperTicker = ticker.toUpperCase();
  
  // Evaluar longitud del ticker
  const tickerScore = upperTicker.length === 3 ? 90 : 60;
  
  // Verificar si es un ticker conocido
  const isKnown = KNOWN_TICKERS.includes(upperTicker);
  
  return [
    { 
      name: 'Risk', 
      value: isKnown ? 90 : Math.floor(Math.random() * (70 - 40) + 40) // Rango 40-70 para desconocidos
    },
    { 
      name: 'Community', 
      value: isKnown ? 100 : Math.floor(Math.random() * (60 - 30) + 30) // Rango 30-60 para desconocidos
    },
    { 
      name: 'Tech', 
      value: tickerScore // Basado en la longitud del ticker
    }
  ];
};

const ProjectAnalysis = () => {
  const [ticker, setTicker] = useState('');
  const [data, setData] = useState(generateAnalysis(''));
  const [isAnalyzed, setIsAnalyzed] = useState(false);

  const handleAnalyze = () => {
    if (!ticker.trim()) return;
    setData(generateAnalysis(ticker));
    setIsAnalyzed(true);
  };

  return (
    <Card className="bg-gray-900 border-purple-500">
      <CardHeader>
        <div className="flex items-center gap-2">
          <TrendingUp className="text-purple-500" />
          <CardTitle className="text-xl font-bold text-white">Project Analysis</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="mb-4">
          <div className="flex gap-2">
            <input
              type="text"
              value={ticker}
              onChange={(e) => setTicker(e.target.value)}
              className="flex-1 bg-gray-800 rounded p-2 border border-purple-500 focus:outline-none focus:border-pink-500"
              placeholder="Enter project ticker..."
            />
            <button 
              onClick={handleAnalyze}
              className="bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded flex items-center gap-2"
            >
              <Search className="w-4 h-4" />
              Analyze
            </button>
          </div>
          {isAnalyzed && (
            <div className="mt-2 text-sm text-gray-400">
              Analysis completed for {ticker.toUpperCase()}
            </div>
          )}
        </div>

        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#444" />
              <XAxis dataKey="name" stroke="#fff" />
              <YAxis stroke="#fff" domain={[0, 100]} />
              <Tooltip 
                contentStyle={{ backgroundColor: '#1a1a1a', border: '1px solid #666' }}
                formatter={(value) => `${value}%`}
              />
              <Line 
                type="monotone" 
                dataKey="value" 
                stroke="#ec4899" 
                strokeWidth={2}
                dot={{ fill: '#ec4899' }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProjectAnalysis;